// https://observablehq.com/@namitmohale/zoomable-sunburst@660
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Zoomable Sunburst

This variant of a [sunburst diagram](/@d3/sunburst) shows only two layers of the hierarchy at a time. Click a node to zoom in, or the center to zoom out. Compare to an [icicle](/@d3/zoomable-icicle).`
)});
  main.variable(observer("chart")).define("chart", ["partition","data","d3","width","titleOffset","centerFontSize","centerText","titleText","titleY","titleSize","color","arc","format","labelFontSize","subStringLength","radius"], function(partition,data,d3,width,titleOffset,centerFontSize,centerText,titleText,titleY,titleSize,color,arc,format,labelFontSize,subStringLength,radius)
{
  const root = partition(data);

  root.each(d => d.current = d);

  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, width+titleOffset])
      .style("font", "6px sans-serif");
  
  // svg.append('text')
  //   .text(centerText)
  //   .attr('y', width/2)
  //   .attr('x', (width/2)-centerText.length*2)
  //   .attr('font-size', centerFontSize)
  //   .attr('margin-left', radius)
  //   .attr('margin-right', radius)
  
  svg.append('g').append('text')
    .attr('fill', 'black')
    .attr('font-size', centerFontSize)
      .join('text')
      .attr('y', (width)/2+titleOffset)
      .attr('x', width/2)
      .attr("text-anchor", "middle")
      .style("alignment-baseline", "central")
      .attr('font-weight', 'bold')
      // .attr('x', (width/2)-centerText.length*2 + offset)
      .text(centerText);
  
  svg.append('text')
     .attr('class', 'title')
     .text(titleText)
     .attr('y', titleY)
     .attr('x', width/2)
      .attr("text-anchor", "middle")
      .style("alignment-baseline", "middle")
      .attr('font-weight', 'bold')
     .attr('font-size', titleSize);

  const g = svg.append("g")
      .attr("transform", `translate(${(width) / 2},${(width) / 2 + titleOffset})`);

  const path = g.append("g")
    .selectAll("path")
    .data(root.descendants().slice(1))
    .join("path")
      .attr("fill", d => { while (d.depth > 1) d = d.parent; return color(d.data.name); })
      .attr("fill-opacity", d => arcVisible(d.current) ? (d.children ? 0.6 : 0.4) : 0)
      .attr("d", d => arc(d.current));

  path.filter(d => d.children)
      .style("cursor", "pointer")
      .on("click", clicked);

  path.append("title")
      .text(d => `${d.ancestors().map(d => d.data.name).reverse().join("/")}\n${format(d.value)}`);

  const label = g.append("g")
      .attr("pointer-events", "none")
      .attr("text-anchor", "middle")
      .style("user-select", "none")
    .selectAll("text")
    .data(root.descendants().slice(1))
    .join("text")
      .attr("dy", ".35em")
      .attr("fill-opacity", d => +labelVisible(d.current))
      .attr("transform", d => labelTransform(d.current))
      .style("font-size", labelFontSize)
      .text(d => d.data.name.length > subStringLength ? d.data.name.substring(0,subStringLength)+"..." : d.data.name)
        // .call(wrap, d => d.data.name)
      ;

  const parent = g.append("circle")
      .datum(root)
      .attr("r", radius)
      .attr("fill", "none")
      .attr("pointer-events", "all")
      .on("click", clicked);
  
   // svg.append('text')
   //  .text(centerText)
   //  .attr('y', width/2)
   //  .attr('x', (width/2)-centerText.length*2)
   //  .attr('font-size', centerFontSize)
   //  .attr('margin-left', radius)
   //  .attr('margin-right', radius)
  
  

  function clicked(event, p) {
    parent.datum(p.parent || root);

    root.each(d => d.target = {
      x0: Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
      x1: Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
      y0: Math.max(0, d.y0 - p.depth),
      y1: Math.max(0, d.y1 - p.depth)
    });

    const t = g.transition().duration(750);

    // Transition the data on all arcs, even the ones that aren’t visible,
    // so that if this transition is interrupted, entering arcs will start
    // the next transition from the desired position.
    path.transition(t)
        .tween("data", d => {
          const i = d3.interpolate(d.current, d.target);
          return t => d.current = i(t);
        })
      .filter(function(d) {
        return +this.getAttribute("fill-opacity") || arcVisible(d.target);
      })
        .attr("fill-opacity", d => arcVisible(d.target) ? (d.children ? 0.6 : 0.4) : 0)
        .attrTween("d", d => () => arc(d.current));

    label.filter(function(d) {
        return +this.getAttribute("fill-opacity") || labelVisible(d.target);
      }).transition(t)
        .attr("fill-opacity", d => +labelVisible(d.target))
        .attrTween("transform", d => () => labelTransform(d.current));
  }
  
  function arcVisible(d) {
    return d.y1 <= 3 && d.y0 >= 1 && d.x1 > d.x0;
  }

  function labelVisible(d) {
    return d.y1 <= 3 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
  }

  function labelTransform(d) {
    const x = (d.x0 + d.x1) / 2 * 180 / Math.PI;
    const y = (d.y0 + d.y1) / 2 * radius;
    return `rotate(${x - 90}) translate(${y},0) rotate(${x < 180 ? 0 : 180})`;
  }

  return svg.node();
}
);
  main.variable(observer("titleY")).define("titleY", function(){return(
10
)});
  main.variable(observer("titleOffset")).define("titleOffset", function(){return(
50
)});
  main.variable(observer("titleSize")).define("titleSize", function(){return(
18
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"Average Perk Budget per Team/Category"
)});
  main.variable(observer("offset")).define("offset", function(){return(
0
)});
  main.variable(observer("centerFontSize")).define("centerFontSize", function(){return(
12
)});
  main.variable(observer("labelFontSize")).define("labelFontSize", ["radius"], function(radius){return(
radius/12
)});
  main.variable(observer("subStringLength")).define("subStringLength", function(){return(
15
)});
  main.variable(observer("fontSize")).define("fontSize", function(){return(
10
)});
  main.variable(observer("centerText")).define("centerText", ["textBeforeSum","totalSum"], function(textBeforeSum,totalSum){return(
textBeforeSum+": $"+totalSum.toFixed(2)
)});
  main.variable(observer("textBeforeSum")).define("textBeforeSum", function(){return(
"Total Budget"
)});
  main.variable(observer("totalSum")).define("totalSum", ["data"], function(data)
{var findSum = (obj) => {
  var result = 0
  for(var prop in obj){
    const value = obj[prop]
    if (prop === "value"){
      result += obj[prop]
    }
    if (prop === "children"){
      value.forEach(subVal => {
        result += findSum(subVal)
      })
    }
  }
  return result
}
return findSum(data)
}
);
  main.variable(observer("data")).define("data", function(){return(
{
  "name": "organization",
  "children": [
    {
      "name": "Expense",
      "children": [
        {
          "name": "Product Management",
          "children": [
            {
              "name": "Vamsi Raju",
              "value": 0
            },
            {
              "name": "Rohit Sharma",
              "value": 0
            },
            {
              "name": "Sanch Roy",
              "value": 850
            },
            {
              "name": "Conor Mcgregor",
              "value": 850
            },
            {
              "name": "Shrey Porey",
              "value": 0
            }
          ]
        },
        {
          "name": "Marketing",
          "children": [
            {
              "name": "Warner Joe",
              "value": 1000
            },
            {
              "name": "Omkar Seth",
              "value": 0
            },
            {
              "name": "Utkar Polly",
              "value": 0
            },
            {
              "name": "Amanda Cerny",
              "value": 0
            },
            {
              "name": "Joe Rogan",
              "value": 0
            }
          ]
        },
        {
          "name": "Human Resources",
          "children": [
            {
              "name": "Moiz Khan",
              "value": 0
            },
            {
              "name": "Heem Shah",
              "value": 0
            },
            {
              "name": "Tom Cruise",
              "value": 0
            },
            {
              "name": "Asif Shaikh",
              "value": 0
            },
            {
              "name": "Brad Pitt",
              "value": 0
            }
          ]
        },
        {
          "name": "Data",
          "children": [
            {
              "name": "MS Dhoni",
              "value": 500
            },
            {
              "name": "Steve Smith",
              "value": 0
            },
            {
              "name": "Virat Kohli",
              "value": 0
            },
            {
              "name": "Vatsal Kumar",
              "value": 0
            },
            {
              "name": "Sachin Tendulkar",
              "value": 0
            }
          ]
        },
        {
          "name": "Development",
          "children": [
            {
              "name": "Lionel Messi",
              "value": 200
            },
            {
              "name": "Appy Jordan",
              "value": 0
            },
            {
              "name": "Tom Hardy",
              "value": 200
            },
            {
              "name": "Stuart Binny",
              "value": 0
            },
            {
              "name": "Michael Jordan",
              "value": 0
            }
          ]
        }
      ]
    },
    {
      "name": "Perks",
      "children": [
        {
          "name": "Product Management",
          "children": [
            {
              "name": "Vamsi Raju",
              "value": 220
            },
            {
              "name": "Rohit Sharma",
              "value": 220
            },
            {
              "name": "Sanch Roy",
              "value": 220
            },
            {
              "name": "Conor Mcgregor",
              "value": 220
            },
            {
              "name": "Shrey Porey",
              "value": 220
            }
          ]
        },
        {
          "name": "Marketing",
          "children": [
            {
              "name": "Warner Joe",
              "value": 200
            },
            {
              "name": "Omkar Seth",
              "value": 200
            },
            {
              "name": "Utkar Polly",
              "value": 200
            },
            {
              "name": "Amanda Cerny",
              "value": 200
            },
            {
              "name": "Joe Rogan",
              "value": 200
            }
          ]
        },
        {
          "name": "Human Resources",
          "children": [
            {
              "name": "Moiz Khan",
              "value": 250
            },
            {
              "name": "Heem Shah",
              "value": 250
            },
            {
              "name": "Tom Cruise",
              "value": 250
            },
            {
              "name": "Asif Shaikh",
              "value": 250
            },
            {
              "name": "Brad Pitt",
              "value": 250
            }
          ]
        },
        {
          "name": "Data",
          "children": [
            {
              "name": "MS Dhoni",
              "value": 100
            },
            {
              "name": "Steve Smith",
              "value": 100
            },
            {
              "name": "Virat Kohli",
              "value": 100
            },
            {
              "name": "Vatsal Kumar",
              "value": 100
            },
            {
              "name": "Sachin Tendulkar",
              "value": 100
            }
          ]
        },
        {
          "name": "Development",
          "children": [
            {
              "name": "Lionel Messi",
              "value": 300
            },
            {
              "name": "Appy Jordan",
              "value": 300
            },
            {
              "name": "Tom Hardy",
              "value": 300
            },
            {
              "name": "Stuart Binny",
              "value": 300
            },
            {
              "name": "Michael Jordan",
              "value": 300
            }
          ]
        }
      ]
    }
  ]
}
)});
  main.variable(observer("partition")).define("partition", ["d3"], function(d3){return(
data => {
  const root = d3.hierarchy(data)
      .sum(d => d.value)
      .sort((a, b) => b.value - a.value);
  return d3.partition()
      .size([2 * Math.PI, root.height + 1])
    (root);
}
)});
  main.variable(observer("color")).define("color", ["d3","colorType","data"], function(d3,colorType,data){return(
d3.scaleOrdinal(d3.quantize(colorType, data.children.length + 1))
)});
  main.variable(observer("colorType")).define("colorType", ["d3"], function(d3){return(
d3.interpolateCool
)});
  main.variable(observer("format")).define("format", ["d3"], function(d3){return(
d3.format(",d")
)});
  main.variable(observer("radius")).define("radius", ["width"], function(width){return(
width / 6
)});
  main.variable(observer("arc")).define("arc", ["d3","radius"], function(d3,radius){return(
d3.arc()
    .startAngle(d => d.x0)
    .endAngle(d => d.x1)
    .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
    .padRadius(radius * 1.5)
    .innerRadius(d => d.y0 * radius)
    .outerRadius(d => Math.max(d.y0 * radius, d.y1 * radius - 1))
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  return main;
}
